import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MailService {

  constructor(private http: HttpClient) { }

  inviaMail(form: any) {
    return this.http.post<any>("https://mailwing.lunalabs.it/api/submit-form", form )
  }
}
